import { useEffect, useState } from "react";
import isAuthenticated from "../../../../components/Utils/isAuthenticated";
import {
	useFacultyRank,
	useAddInstructorToFacultyRank,
} from "../../../../Hooks/useFacultyRankQuery";
import FacultyRankAutocomplete from "../../../../components/Utils/FacultyRankAutocomplete";
import ListSelect from "../../../../components/Utils/ListSelect";
import { Button } from "@mui/material";
import { useAtom, useSetAtom } from "jotai";
import { selectedClassAtom, unsavedChangesAtom } from "../../../../components/Atoms/atoms";

const classRoles = ["PI", "TA", "CC", "CO", "LA", "GL", "AI", "PG", "SG", "TC", "DA"];
const rolesDescriptions = {
	PI: "Primary Instructor",
	TA: "Teaching Assistant",
	CC: "Course Coordinator",
	CO: "Co-Instructor",
	LA: "Learning Assistant",
	GL: "Grader/Lab Assistant",
	AI: "Assistant Instructor",
	PG: "Primary Grader",
	SG: "Secondary Grader",
	TC: "Teaching Coordinator",
	DA: "Department Assistant",
};

export default function ClassAdjustAddInstructor(props) {
	const { isInInstance, setAddInstructor, rows, setRows, originalRows } = props;
	let auth = isAuthenticated();
	const [selectedClass, setSelectedClass] = useAtom(selectedClassAtom);
	const setUnsavedChanges = useSetAtom(unsavedChangesAtom);
	const token = auth.token;
	const { data: facultyRank } = useFacultyRank(token);

	const [deptId, setDeptId] = useState("");
	const [instructorRole, setInstructorRole] = useState("");
	const [existingRoles, setExistingRoles] = useState([]);

	const [newRoleValue, setNewRoleValue] = useState("");

	useEffect(() => {
		if (selectedClass?.dept) setDeptId(selectedClass.dept);
	}, [selectedClass]);

	const { addInstructorToFacultyRank } = useAddInstructorToFacultyRank(token, deptId);

	const addInstructor = async (instructorToAdd) => {
		const success = await addInstructorToFacultyRank(instructorToAdd);
		return success;
	};

	const handleChangeRole = (event) => {
		setInstructorRole(event.target.value);
	};

	const handleAddInstructor = async () => {
		const instructorToAdd = newRoleValue;

		let newRole = {};

		const updatedRows = rows.map((classObj) => {
			if (classObj.classid === selectedClass.classid) {
				newRole = {
					ccid: instructorToAdd.ccid,
					class_role: instructorRole,

					checked: false,
					classid: classObj.classid,
					disabled: false,
					empid: instructorToAdd.empid,
					name: instructorToAdd.name,
					first_name: instructorToAdd.name.split(", ")[0],
					last_name: instructorToAdd.name.split(", ")[1],
					role_description: rolesDescriptions[instructorRole],
					roleid: Number(instructorToAdd.empid) + classObj.classid,
					term: classObj.term,
					import_status: "MANUAL",
				};

				if (classObj.teamsize === 0 || (classObj.teamsize !== 0 && classObj.roles.length === 0)) {
					return {
						...classObj,
						name: instructorToAdd.name,
						empid: instructorToAdd.empid,

						class_role: instructorRole,
						teamsize: 1,
						comb_classes: [],
						roles: [newRole],
					};
				} else {
					const updatedRoles = [...classObj.roles, newRole];
					const teamNames = updatedRoles.map((role) => `'${role.name}'`).join(", ");
					return {
						...classObj,
						roles: updatedRoles,
						teamName: teamNames,
						teamsize: classObj.teamsize + 1,
					};
				}
			}
			return classObj;
		});

		// Create a new array instance to trigger re-render
		setRows([...updatedRows]);

		//update selectedClass
		const updatedSelectedClass = updatedRows.find(
			(classObj) => classObj.classid === selectedClass.classid,
		);
		setSelectedClass(updatedSelectedClass);

		const isChanged = JSON.stringify(originalRows) !== JSON.stringify(updatedRows);
		if (!isInInstance) setUnsavedChanges(isChanged);

		if (!isInInstance) setAddInstructor(false);

		setInstructorRole("");
		/* await addRoles(newRole); */
		//if successful reset the search and role
	};

	const checkExistingFacultyRank = (empid) => {
		let exists = false;
		facultyRank.forEach((rank) => {
			if (Number(rank.empid) === Number(empid)) {
				exists = true;
			}
		});
		return exists;
	};

	const handleCancelAddInstructor = () => {
		setAddInstructor(false);
		setInstructorRole("");
	};

	return (
		<div>
			<div className="text-[11px] font-semibold uppercase tracking-[0.16em] text-darkGreen mb-1">
				Add Instructor
			</div>
			<div className="flex gap-2 w-full items-center">
				<FacultyRankAutocomplete
					options={facultyRank}
					currentRow={selectedClass}
					setExistingRoles={setExistingRoles}
					isInInstance={isInInstance}
					newRoleValue={newRoleValue}
					setNewRoleValue={setNewRoleValue}
					checkExistingFacultyRank={checkExistingFacultyRank}
					addInstructorToFacultyRank={addInstructor}
					size="small"
				/>
				<ListSelect
					required
					size="small"
					marginBottom="0"
					label="Role"
					value={instructorRole}
					onChange={handleChangeRole}
					list={classRoles}
					width={100}
				/>
			</div>
			<div className="flex items-center pt-2 w-full gap-2">
				<Button
					size="small"
					variant="contained"
					color="error"
					className=" w-1/2"
					onClick={handleCancelAddInstructor}
				>
					Cancel
				</Button>
				{isInInstance && (
					<Button
						size="small"
						className="bg-white text-green-800  rounded-md hover:text-white hover:bg-green-900 w-1/2 border-2 border-green-900"
						onClick={() => {
							setAddInstructor(false);
						}}
					>
						Done
					</Button>
				)}
				<Button
					size="small"
					variant="contained"
					color="primary"
					disabled={!newRoleValue || !instructorRole}
					onClick={handleAddInstructor}
					sx={{ width: "50%" }}
				>
					Add
				</Button>
			</div>
		</div>
	);
}
